<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-25 19:02:38
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 13:58:51
 * @Description: file content
 -->

<template>
  <div>
    <router-view></router-view>
    <ActBaseMusic
      :option="{audioSrc:this.$config.audioSrc,style:{right:'8px',top:'58px'}}"
    ></ActBaseMusic>
    <ActBaseBottom :option="$config.company"></ActBaseBottom>
  </div>
</template>
<script>
import Vue from "vue/dist/vue.js";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    if (!this.$infoId) {
      Vue.prototype.$infoId = this.$util.cookie.get('infoId')
    }
    if (!this.$key) {
      Vue.prototype.$key = this.$util.cookie.get('key')
    }
    if (!this.$mobile) {
      Vue.prototype.$mobile = this.$util.cookie.get('mobile')
    }
    Vue.config.ignoredElements = ["wx-open-launch-weapp", "wx-open-launch-app"];
    if (this.$userInfo) {
      let postObj = {
        channel: this.$channel,
        referenceOpenid: this.$fopenid
      };
      if (this.$userInfo.headImgUrl) {
        postObj.headImg = this.$userInfo.headImgUrl;
      }
      if (this.$userInfo.nickName) {
        postObj.nickname = this.$userInfo.nickName;
      }
      if (this.$userInfo.openId) {
        postObj.openid = this.$userInfo.openId;
      }
      let url = "";
      if (this.$avoidWeChatBug == 1) {
        url = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&avoidWeChatBug=0`;
      } else {
        url = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&avoidWeChatBug=1`;
      }
      this.$wx.setShare(
        `澳朵花园邀您一起狂欢欧洲杯`,
        "参与线上竞猜，赢得澳朵金豆，兑换精彩好礼！",
        url,
        `${this.$config.imgHost}fx.jpg`
      );
      this.$wx.shareCallBackFunList.push("share1", () => {
        this.$httpdf.get(this.apiHost + 'fc/share');
      });
    }
  },
  mounted() {}
};
</script>

<style lang="css" scoped>
</style>